import AggregatedRatingTag from './AggregatedRatingTag';

export default AggregatedRatingTag;
